'use client';

import React from 'react';
import { OrderOperation, OrdersListItemType } from '../types';
import { AssetImage, HyperLinkButtonBase } from '@bts-web/core-features/common';
import { css } from '@bts-web/utils-style-engine';
import { RegularChevronRight } from '../../common/svgIcons';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { formattedAmount } from './CurrencyFormatting';

interface OrderListItemProps {
  item: OrdersListItemType;
}

function OrderListItem({ item }: OrderListItemProps) {
  const { t } = useClientTranslation();

  const formattedFiat = formattedAmount(
    item?.fiatAmount ?? { value: '0', precision: 2 },
  );

  const formattedTarget = formattedAmount(item?.targetPrice);

  return (
    <HyperLinkButtonBase
      visual="ghost"
      noPadding
      fullWidth
      to={`/orders/${item?.id}`}
    >
      <div
        className={css({
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          borderBottomColor: 'neutrals.divider',
          borderBottomWidth: '1px',
          gap: 'small',
          padding: 'medium',
          width: '100%',
        })}
      >
        <AssetImage
          src={item?.asset?.logoUrl ?? ''}
          alt={item?.asset?.name ?? ''}
          height={24}
          width={24}
          placeholder="empty"
        />

        <div className={css({ display: 'flex', flexDirection: 'column' })}>
          <h3>{item?.asset?.name}</h3>
          <div
            className={css({
              display: 'flex',
              flexDirection: 'row',
              gap: 'extra_small_4',
              color: 'neutrals.text_secondary',
              fontSize: 'body.medium',
              fontWeight: 'body.medium',
              letterSpacing: 'body.medium',
              lineHeight: 'body.medium',
            })}
          >
            <p>
              {item?.operation === OrderOperation.BUY
                ? t('buy_asset', { asset: formattedFiat })
                : t('sell_asset', { amount: formattedFiat, ticker: '' })}
            </p>
          </div>
        </div>

        <div
          className={css({
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginInlineStart: 'auto',
          })}
        >
          <p>{t('at_amount', { amount: formattedTarget })}</p>
          <RegularChevronRight size={18} data-dir="rtl" />
        </div>
      </div>
    </HyperLinkButtonBase>
  );
}

export default OrderListItem;
